const config = {
  APP_NAME: process.env.REACT_APP_NAME,
  SOCKET_URL: process.env.REACT_APP_SOCKET_URL,
  API_BASE_URL:process.env.REACT_APP_API_URL,
  MEDIA_UPLOAD_SIZE:process.env.REACT_APP_FILE_SIZE,
};

export default config;
